import React from 'react';
import PropTypes from 'prop-types';
import {isEmptyObject} from 'utils/misc';
import {connect} from 'react-redux';
import {getConsentContent} from '../contentful/actions';


class WithConsentUnConnected extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        onError: PropTypes.func,
        consents: PropTypes.object,
        type: PropTypes.string.isRequired,
        getConsentContent: PropTypes.func.isRequired
    };

    static defaultProps = {
        onError: (error) => <span>{error}</span>
    };

    notLoaded = () => {
        return isEmptyObject(this.props.consents.data) && !this.props.consents.loading;
    };

    isLoading = () => {
        return isEmptyObject(this.props.consents.data) || this.props.consents.loading;
    };

    componentDidMount() {
        if (this.notLoaded()) {
            this.props.getConsentContent();
        }
    }

    componentDidUpdate() {
        // If the locale is changed, the component is updated and the redux-store is cleared,
        // therefore it needs to fetch to content again.
        if (this.notLoaded()) {
            this.props.getConsentContent();
        }
    }

    render() {
        const {consents, children, onError, type} = this.props;
        return consents.error ? onError() : children({
            loading: this.isLoading(),
            consent: consents.data[type] ? consents.data[type] : {}
        });
    }
}

function mapStateToProps(state) {
    return {
        consents: state.content.consent
    };
}

const mapDispatchToProps = {getConsentContent};

export const WithConsent = connect(mapStateToProps, mapDispatchToProps)(WithConsentUnConnected);

WithConsent.propTypes = {
    type: PropTypes.string.isRequired,
    children: PropTypes.func.isRequired,
    onError: PropTypes.func
};
